import jQuery from "jquery";
window.$ = window.jQuery = jQuery;

import Rails from "@rails/ujs";
import "bootstrap/dist/js/bootstrap.bundle";
import "./vendor/bootstrap-select";
import "./nested_form_fields";

Rails.start();

$(function () {
  $('[data-toggle="tooltip"]').tooltip();

  $(".selectpicker.poly_select").each(function () {
    $(this).selectpicker(
      "val",
      $("#" + this.id + "_type").val() + ":" + $("#" + this.id + "_id").val()
    );
  });

  $("input.date-begin").on("change", function () {
    const end = document.getElementById(this.id.replace("begin", "end"));
    end.min = this.value;
    if (!end.value && this.value.length > 10) {
      const d = new Date(this.value);
      d.setHours(d.getHours() + 2);
      end.value = d.toLocaleString("sv").replace(" ", "T").slice(0, 16);
    }
  });

  const dateTimeToggler = $("input.date-time-toggler");
  if (dateTimeToggler.length) {
    toggleDateTime(dateTimeToggler.prop("checked"));
  }
  dateTimeToggler.change(function (e) {
    toggleDateTime(e.target.checked);
  });

  if (localStorage.getItem("darkmodeOn") == "true") {
    $("body").addClass("dark");
  }
  $("button.darkmode-toggler").click(function () {
    $("body").toggleClass("dark");
    localStorage.setItem("darkmodeOn", $("body").hasClass("dark"));
  });

  if (localStorage.getItem("sidebarOn") == "true") {
    $("#mr-wrapper").addClass("full-sb");
    setTimeout(function () {
      $("#mr-wrapper").addClass("sb-ready");
    });
  } else {
    $("#mr-wrapper").addClass("sb-ready");
  }

  $("#mr-wrapper.full-sb #mr-sidebar [data-toggle='tooltip']").tooltip("disable");

  $(".add_nested_fields_link").click(function () {
    setTimeout(function () {
      $(".selectpicker").selectpicker();
    }, 10);
  });

  $(".parent a").click(function () {
    $("#mr-wrapper").addClass("full-sb");
    $(".parent a").not($(this)).parent().removeClass("open");
    $(this).parent().toggleClass("open");
    $(".parent a").not($(this)).parent().children("ul").slideUp();
    $(this).parent().children("ul").slideToggle();
    $("#mr-sidebar [data-toggle='tooltip']").tooltip("disable");
  });

  $(".sidebar-toggler").click(function () {
    $("#mr-wrapper").toggleClass("full-sb");
    localStorage.setItem("sidebarOn", $("#mr-wrapper").hasClass("full-sb"));
    $("#mr-sidebar [data-toggle='tooltip']").tooltip("toggleEnabled");
    $(".parent a").parent().removeClass("open");
    $(".parent a").parent().children("ul").css("display", "none");
  });

  $("#johnny-rainbow").dblclick(function () {
    $("body").toggleClass("disco");
  });

  $(".wiki_content a[href^='#']").click(function (e) {
    e.preventDefault();
    const margin = 20;
    const pos =
      $($(this).attr("href")).offset().top -
      $("nav.navbar.fixed-top").outerHeight() -
      margin;
    $("html, body").animate({ scrollTop: pos }, 800, "swing");
  });

  $("a").click(function (e) {
    const href = $(this).attr("href");
    if (!href) return;
    const url = new URL(href, window.location.origin);
    if (
      url.protocol === "http:" ||
      (url.protocol === "https:" &&
        !url.hostname.endsWith(".rotaract.de") &&
        url.origin !== window.location.origin)
    ) {
      const confirmed = confirm(
        "Du verlässt nun mein Rotaract und besuchst \n" +
          url.href +
          "\n\nBist du sicher?"
      );
      if (!confirmed) {
        e.preventDefault();
      }
    }
  });
});

window.setPolyType = function (elem) {
  $("#" + elem.id + "_type").val(elem.value.split(":")[0]);
  $("#" + elem.id + "_id").val(elem.value.split(":")[1]);
};

window.toggleDateTime = function (allDay) {
  $("input.datetimepicker").each(function () {
    const value = this.value;
    this.type = allDay ? "date" : "datetime-local";
    this.value = allDay ? value.slice(0, 10) : value.length === 10 ? value + "T19:00" : value;
  });
};
